import { reject, sortBy } from 'lodash'
// import Moment from 'moment'

export function extensions ({ products }) {
  // filter out deprecated uninstalled extensions
  return sortBy(reject(products.extensions,
    { deprecated: true, installed: false }
  ), extension => [
    // and sortBy
    !extension.installed,
    !extension.deprecated,
    !extension.outdated,
    !extension.subscribed
  ])
}

export function languages ({ products }) {
  return sortBy(products.languages, ['installed'])
}

// export function subscriptions ({ products }) {
//   return sortBy(products.subscriptions, (sub) =>
//     Moment().diff(Moment(sub.creationDate), 'days')
//   )
// }



/** WEBPACK FOOTER **
 ** ./src/vuex/getters.js
 **/